module.exports = __webpack_public_path__ + "img/IntelliseqFlow-dark-claim.3c50f2ee.svg";